// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosPromise } from 'axios';

import { authDelete, authGet, authPost, authPut, parseCamelCase, parseSnakeCase } from './util';
import { Chapter, Progress, OnlineCourse, Note, SearchCondition, PaginationListResponse } from '../types/Model';
import { ProductCard } from '../components/NewCard/types';
const baseURL = '/course';

export const getOnlineCourseData = (id: number): AxiosPromise => {
  return authGet(`${baseURL}/onlineCourses/${id}/information`, {
    transformResponse: (onlineCourse: OnlineCourse) => parseCamelCase(onlineCourse)
  });
};

interface OnlineCourseChapters {
  chapters: Chapter[];
  progress: Progress[];
}

export const getOnlineCourseContentsData = (id: number): AxiosPromise<OnlineCourseChapters> => {
  function parseQuiz(module: any) {
    if (module.type === 'quiz') {
      const answers = module.questions.map((question: any) =>
        question.options.reduce(
          (pre: string, cur: any, index: number) =>
            pre + (cur.answer ? String.fromCharCode(index + 65) : ''),
          ''
        )
      );
      const examData = module.questions.map((question: any) => ({
        title: question.description,
        options: question.options.map((option: any) => option.content)
      }));
      const explains = module.questions.map((question: any) => {
        return question.options.reduce(
          (pre: object, cur: any, index: number) => {
            if (cur.explain) {
              return {
                ...pre,
                [String.fromCharCode(index + 65)]: cur.explain
              };
            }
            return pre;
          },
          {}
        );
      });

      return {
        answers,
        examData,
        explains
      };
    }

    return {
      answers: [],
      examData: [],
      explains: []
    };
  }

  return authGet(`${baseURL}/onlineCourses/${id}/contents`, {
    transformResponse: (data: any) => {
      if (typeof data === 'string') {
        throw data;
      }

      const {
        chapters,
        ...onlineCourse
      } = parseCamelCase(data);
      const parsed = {
        ...onlineCourse,
        chapters: chapters.map(
          ({ modules, ...chapter }: any, index: number) => ({
            id: index + 1,
            ...chapter,
            modules: modules.map((module: any) => ({
              ...module,
              videoUrl: module.videoUrls && module.videoUrls.hlsGroup.find((hls: any) => hls.type === 'Auto').url,
              ...parseQuiz(module)
            }))
          })
        ),
      };

      return parsed;
    }
  });
};

interface UpdateProgress {
  revisedTime: Date;
  progress: Progress[];
}

export const updateOnlineCourseProgress = (id: number, progress: Progress): AxiosPromise<UpdateProgress> => {
  return authPost(`${baseURL}/onlineCourses/${id}/progress`, parseSnakeCase(progress), {
    transformResponse: (data: any) => parseCamelCase(data)
  })
}

export const getOnlineCourseNotes = (id: number) => {
  return authGet(`${baseURL}/onlineCourses/${id}/note`, {
    transformResponse: (note) => parseCamelCase(note)
  });
}

export const createOnlineCourseNotes = (id:number, vodId:number, time:number, note:string) => {
  return authPost(`${baseURL}/onlineCourses/${id}/note`,
    parseSnakeCase({ vodId, note, time }), {
      transformResponse: (data: any) => parseCamelCase(data)
    })
}

export const updateOnlineCourseNotes = (id:number, noteId: string, note: string) => {
  return authPost(`${baseURL}/onlineCourses/${id}/note/${noteId}`, parseSnakeCase({ note }), {
    transformResponse: (data: any) => parseCamelCase(data)
  })
}

export const deleteOnlineCourseNotes = (id:number, noteId: string) => {
  return authDelete(`${baseURL}/onlineCourses/${id}/note/${noteId}`, {
    transformResponse: (data: any) => parseCamelCase(data)
  })
}

export const searchOnlineCourses = (limit: number, page: number, params: SearchCondition): AxiosPromise<PaginationListResponse<ProductCard>> => {
  return authPost(`${baseURL}/onlineCourses/search`, parseSnakeCase({
    limit: limit,
    page: page,
    name: params.name || undefined,
    platformIds: params.platformId ? [params.platformId] : undefined,
    domainIds: params.domainIds.length > 0 ? params.domainIds : undefined,
    levelIds: params.levelId ? [params.levelId] : undefined,
  }), {
    transformResponse: (data: any) => parseCamelCase(data.result)
  });
};

export const searchOnlineCoursesKeyword = (limit: number, name?: string): AxiosPromise => {
  return authPost(`${baseURL}/onlineCourses/keyword`, parseSnakeCase({
    limit: limit,
    name: name || undefined
  }), {
    transformResponse: (data: any) => parseCamelCase(data.result)
  });
};

export const sendVisitedOnlineCourse = (id: number): AxiosPromise => {
  return authPut(`${baseURL}/onlineCourses/visitor/${id}`, {
    responseType: 'json'
  });
}

export const downloadOnlineCourseResult = (id:number, choosedUser: number[]) => {
  return authPost(`${baseURL}/onlineCourses/${id}/downloadResult`, parseSnakeCase({
    choosedUser
  }), {
    responseType: 'blob',
  })
}
